import styled from "styled-components";
import { Label, Resource } from "./Resource";
import { DraggableLocation, Droppable } from "@hello-pangea/dnd";
import { IResource, IDraggableAlignmentResultSection } from "store/types";
import { Grid, IconButton } from "@mui/material";
import { SectionHeader } from "./SectionHeader";
import { useCallback, useRef, useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Aligned } from "components/Layout";
import { noop } from "lodash";
import useKeyPress from "lib/keypress";

export const ResourceList = styled.div<{ isdraggingover?: string; sidebar?: string }>`
  padding-left: ${(props) => (props.sidebar === "true" ? "2px" : "14px")};
  padding-right: ${(props) => (props.sidebar === "true" ? "4px" : "24px")};
  padding-top: 6px;
  padding-bottom: 6px;
  transition: background-color 0.2s ease;
  border: ${(props) => (props.isdraggingover === "true" ? "1px dashed #9747FF" : "1px solid white")};
  border-radius: 5px;
`;

interface IProps {
  state: any;
  section: IDraggableAlignmentResultSection;
  resources: IResource[];
  onMoveResourceViaMenu: (source: DraggableLocation, destination: DraggableLocation, draggableId: string[]) => any;
  onExcludeResourceViaMenu?: (source: DraggableLocation, draggableId: string[]) => any;
  expand: boolean;
  sidebar: boolean;
  shortcut?: string[];
}

export const Section = ({
  section,
  resources,
  expand,
  sidebar,
  onMoveResourceViaMenu,
  onExcludeResourceViaMenu,
  state,
  shortcut,
}: IProps) => {
  const [expanded, setExpanded] = useState(expand);
  const ref = useRef(null);
  const onKeyPress = (_event: any) => {
    (ref.current as any).focus();
  };
  useKeyPress(shortcut, onKeyPress);

  const flipExpansion = useCallback(() => setExpanded((old) => !old), []);
  const gridStyle = sidebar
    ? { backgroundColor: "#6C6C6C", color: "white", padding: "0px", borderRadius: "0px", margin: "4px" }
    : { padding: "0px", borderRadius: "4px", margin: "4px" };
  const iconStyle = sidebar ? { color: "white" } : {};
  const fontSize = sidebar ? "medium" : "medium";
  const focusStyle = sidebar ? { ":focus": { bgcolor: "#414141", color: "#6C6C6C" } } : {};

  return (
    <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
      <Grid style={gridStyle}>
        <Aligned>
          <IconButton onClick={flipExpansion} ref={ref} sx={focusStyle}>
            {expanded ? (
              <ExpandLessIcon fontSize={fontSize} style={iconStyle} />
            ) : (
              <ExpandMoreIcon fontSize={fontSize} style={iconStyle} />
            )}
          </IconButton>
          <SectionHeader
            state={state}
            section={section}
            sidebar={sidebar}
            column1="Original location"
            column2="Confidence"
            items={resources.length}
            expanded={expanded}
            onMoveResourceViaMenu={onMoveResourceViaMenu}
            onExcludeResourceViaMenu={onExcludeResourceViaMenu}
          />
        </Aligned>
      </Grid>
      <Droppable droppableId={section.uid}>
        {(provided: any, snapshot: any) => (
          <ResourceList
            ref={provided.innerRef}
            {...provided.droppableProps}
            isdraggingover={`${snapshot.isDraggingOver}`}
            sidebar={sidebar.toString()}
          >
            {snapshot.isDraggingOver && (!expanded ? setExpanded(true) : noop)}
            {expanded &&
              resources.map((resource: IResource, index: number) => (
                <Resource
                  key={resource.uid}
                  resource={resource}
                  onMoveResourceViaMenu={onMoveResourceViaMenu}
                  onExcludeResourceViaMenu={onExcludeResourceViaMenu}
                  index={index}
                  sidebar={sidebar}
                  state={state}
                  section={section}
                />
              ))}
            {!expanded && !sidebar && (
              <Grid container>
                <Grid item xs={12}>
                  <div style={{ paddingLeft: "40px" }}>
                    <Label>{resources.length} items</Label>
                  </div>
                </Grid>
              </Grid>
            )}
            {provided.placeholder}
          </ResourceList>
        )}
      </Droppable>
    </Grid>
  );
};
